<template>
    <div>
        <!-- Backdrop -->
        <transition name="fade">
            <div
                v-if="open"
                class="fixed inset-0 z-10 bg-black bg-opacity-25"
                @click="$emit('close')"
            />
        </transition>

        <!-- Drawer -->
        <transition
            :name="position === 'right' ? 'drawer-right' : 'drawer-left'"
            @enter="enter"
            @leave="leave"
            @after-leave="afterLeave"
        >
            <div
                v-if="open"
                class="fixed inset-0 z-20 overflow-hidden"
                @click.self="$emit('close')"
            >
                <!-- Drawer panel -->
                <div
                    :class="[
                        'fixed inset-y-0 flex max-w-full',
                        position === 'right' ? 'right-0 pl-20' : 'left-0 pr-20'
                    ]"
                >
                    <div class="w-screen max-w-md">
                        <div class="flex h-full flex-col overflow-y-scroll bg-white pb-6 shadow-xl">
                            <div class="flex items-center justify-between bg-pink-100 px-4 py-2">
                                <h2 class="text-lg text-gray-900">
                                    {{ title }}
                                </h2>
                                <div class="ml-3 flex h-7 items-center">
                                    <button
                                        type="button"
                                        class="relative rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                        @click="$emit('close')"
                                    >
                                        <span class="absolute -inset-2.5" />
                                        <span class="sr-only">Close panel</span>
                                        <svg
                                            class="w-6 h-6 text-gray-400"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke-width="1.5"
                                            stroke="currentColor"
                                            aria-hidden="true"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M6 18L18 6M6 6l12 12"
                                            />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                            <div class="relative mt-4 flex-1 px-4 sm:px-6">
                                <slot />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'Drawer',
    props: {
        open: {
            type: Boolean,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        position: {
            type: String,
            default: 'right',
            validator(value) {
                return ['left', 'right'].indexOf(value) !== -1;
            },
        },
    },
    methods: {
        enter(element) {
            // Add any enter animation logic if needed
        },
        leave(element) {
            // Add any leave animation logic if needed
        },
        afterLeave(element) {
            // Clean up after leave animation if needed
        },
    },
};
</script>

<style scoped>
.drawer-right-enter-active,
.drawer-right-leave-active,
.drawer-left-enter-active,
.drawer-left-leave-active {
    transition: transform 0.5s ease-in-out;
}

.drawer-right-enter,
.drawer-right-leave-to {
    transform: translateX(100%);
}

.drawer-left-enter,
.drawer-left-leave-to {
    transform: translateX(-100%);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease-in-out;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

@media (min-width: 640px) {
    .drawer-right-enter-active,
    .drawer-right-leave-active,
    .drawer-left-enter-active,
    .drawer-left-leave-active {
        transition-duration: 0.7s;
    }
}
</style>
